<template>
    <div class="">
        <p class="menu-header">Мобильное приложение для урегулирования убытков КАСКО</p>
        <div v-if="mainMenu">
            <a @click="showInsureSubmenu" class="menu-button" v-bind:class="showNewRequestBtns ? 'menu-button-active': ''">
                <img class="menu-button-img" src="/images/menu-new-request.svg">
                <div class="menu-button-text-container">
                    <p class="menu-button-text">Оформить страховой случай</p>  
                    <img class="menu-button-arrow" src="/images/menu-arrow.svg">
                </div>
            </a>
            <div class="request-btns-container" v-if="showNewRequestBtns">
                <a href="/newrequest/" class="center-btn new-report-type">Оформить новый страховой случай</a>
                <a href="/adddocumnents/" class="center-btn new-report-type">Дослать документы</a>
            </div>
        </div>
        <div v-else>
            <a href="/newrequest/" class="menu-button">
                <img class="menu-button-img" src="/images/car-insurance.svg">

                <div class="menu-button-text-container">
                    <p style="margin: 10px 0px 10px 20px;" class="menu-button-text">Оформить новый страховой случай</p>  
                    <img class="menu-button-arrow" src="/images/menu-arrow.svg">
                </div>
            </a>
            <a href="/adddocumnents/" class="menu-button">
                <img class="menu-button-img" src="/images/file.svg">

                <div class="menu-button-text-container">
                    <p style="margin-top: 10px;" class="menu-button-text">Дослать документы</p>  
                    <img class="menu-button-arrow" src="/images/menu-arrow.svg">
                </div>
            </a>
        </div>
    </div>
</template>

<script>
export default {
  name: 'mainmenu',
  data () {
      return {
          mainMenu: true,
          showNewRequestBtns: false,
      }
  },
  methods: {
    showInsureSubmenu() {
        this.showNewRequestBtns = !this.showNewRequestBtns
    },
    openFlitCabinet() {
        window.location.replace("/cabinet/")
    }
  }
  
}
</script>

<style>


</style>



// WEBPACK FOOTER //
// src/MainMenu.vue